import { type CurrencyConstructor } from '@webapp/core/entities/external/Currency'
import { type ApprovedOrderItemConstructor } from '@webapp/modules/purchasing/entities/ApprovedOrderItem'
import { type OrderItemStatusEnum } from '@webapp/modules/purchasing/entities/enums/OrderItemStatusEnum'
import {
  type AccountCodeTypeEnum,
  type AccountConstructor,
} from '@webapp/platform/finance'
import {
  type ApprovedOrderItemAccountApiModel,
  type ApprovedOrderItemApiModel,
} from '../api-models/ApprovedOrderItemApiModel'

export const mapApprovedOrderItemAccountApiModel = (
  account: ApprovedOrderItemAccountApiModel
): AccountConstructor => ({
  id: account.id,
  active: account.active,
  accountCode: {
    id: account.account_code.id,
    code: account.account_code.code,
    description: account.account_code.description,
    type: account.account_code.account_type as AccountCodeTypeEnum,
  },
  secondaryCategory: account.department
    ? {
        id: account.department.id,
        name: account.department.name,
        primaryCategory: account.department.branch
          ? {
              id: account.department.branch.id,
              name: account.department.branch.name,
            }
          : null,
      }
    : null,
})

export const mapApprovedOrderItemApiModel = (
  apiModel: ApprovedOrderItemApiModel
): ApprovedOrderItemConstructor => ({
  id: apiModel.id,
  orderNumber: apiModel.orderNum,
  lineNumber: apiModel.num,
  name: apiModel.name,
  quantity: apiModel.quantity,
  price: apiModel.price,
  totalCost: apiModel.total_cost,
  status: apiModel.status as OrderItemStatusEnum,
  orderUuid: apiModel.order_uuid,
  approvedDate: apiModel.approved_datetime,
  submittedDate: apiModel.submitted_date,
  hasSiblingItems: apiModel.has_sibling_items,
  lineComment: apiModel.lineComment,
  orderDescription: apiModel.order_description,
  currency: apiModel.currency
    ? {
        id: apiModel.currency.id,
        name: apiModel.currency.name as CurrencyConstructor['name'],
        rate: Number(apiModel.currency.rate),
        base: apiModel.currency.base,
      }
    : null,
  requester: apiModel.requester
    ? {
        id: apiModel.requester.id,
        firstName: apiModel.requester.firstName,
        lastName: apiModel.requester.lastName,
      }
    : null,
  account: mapApprovedOrderItemAccountApiModel(apiModel.account),
})
